import React from 'react'

import './GenderBookButton.scss'
import { useTranslation } from 'react-i18next'
import folderOpenIcon from '@assets/images/icons/folder-open.png'
export type GenderBookButtonProps = {
  onClick: () => void
}
export const GenderBookButton = ({ onClick }: GenderBookButtonProps) => {
  const { t } = useTranslation('Result')

  return (
    <div className="GenderBookButton">
      <button onClick={onClick} className="GenderBookButton-Button">
        {t('genderBookButtonLabel')}

        <img className="GenderBookButton-Img" src={folderOpenIcon} />
      </button>
    </div>
  )
}
